/* BeatCredsi brand-mark component — the gold vinyl logo.
 * Used in the Navbar, Footer, and anywhere we want the visual logo
 * instead of (or alongside) the wordmark. */
export default function BrandMark({ size = 48, className = "", showText = false, textClassName = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 select-none ${className}`}>
      <img
        src="/beatcredsi-mark.png"
        alt="BeatCredsi"
        width={size}
        height={size}
        className="shrink-0"
        style={{ width: size, height: size, objectFit: "contain" }}
      />
      {showText && (
        <span className={`font-display font-medium tracking-tight ${textClassName}`}>
          BeatCred<span className="text-amber-500">si</span>
          <span className="text-amber-500 text-[0.55em] align-super">™</span>
        </span>
      )}
    </span>
  );
}
